import { render, staticRenderFns } from "./R10.vue?vue&type=template&id=1d964594&scoped=true"
import script from "./R10.vue?vue&type=script&lang=js"
export * from "./R10.vue?vue&type=script&lang=js"
import style0 from "./R10.vue?vue&type=style&index=0&id=1d964594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d964594",
  null
  
)

export default component.exports